module.exports = __webpack_public_path__ + "img/error-404.7b545496.jpg";